/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect,  useState } from 'react';
import { useSolutionData } from '../hooks/useSolutionData';
import Load from './load';

// Import optimized components
import SolutionHero from '../components/solution/SolutionHero';
import SolutionAbout from '../components/solution/SolutionAbout';
import BenefitsSection from '../components/solution/BenefitsSection';
import LazySection from '../components/about/LazySection';
import fetchAPICustom from '../helper/custom';
import { ImagePath } from '../helper/constants';
const Solution: React.FC = () => {
   const [solTab, setDataWMain] = useState<any>([]);
      const [tabone, setDataMMain] = useState<any>([]);
      const [tabcredit, setDatakavach] = useState<any>([]);
         const [tabProtect, setDataPotect] = useState<any>([]);
          const [loading1, setLoading] = useState<boolean>(true);
          const [error1, setError] = useState<string | null>(null);
        const { data, loading, error } = useSolutionData();
        // Focusable carousel reference
      const imagePath=ImagePath;
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const [retry, setRetry] = useState(0); // for retry trigger
  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
      const loadData = async () => {
        try {
          // main sider gro one app
          setDataWMain(await fetchAPICustom('webslider.php?id=6')); 
          setDataMMain(await fetchAPICustom('webslider.php?id=15')); 
          setDatakavach(await fetchAPICustom('webslider.php?id=16'));
          setDataPotect(await fetchAPICustom('webslider.php?id=17')); 
         
        } catch (err: any) {
  
          setError(err.message);
  
           // Retry after 3 seconds
          setTimeout(() => setRetry((prev) => prev + 1), 10000);
        } finally {
          setLoading(false);
        }
      };
  
      loadData();
    }, [retry]);
  

  for (let i = 0; i < solTab?.data?.slider_images.length; i++) { 
    const slideimg = solTab.data.slider_images[i];
    slideimg.slider_img_url = slideimg.slider_img_url.replace("public://", "");
  }
  for (let i = 0; i < tabone?.data?.slider_images.length; i++) { 
    const slideimg = tabone.data.slider_images[i];
    slideimg.slider_img_url = slideimg.slider_img_url.replace("public://", "");
  }
 for (let i = 0; i < tabcredit?.data?.slider_images.length; i++) { 
    const slideimg = tabcredit.data.slider_images[i];
    slideimg.slider_img_url = slideimg.slider_img_url.replace("public://", "");
  }
   for (let i = 0; i < tabProtect?.data?.slider_images.length; i++) { 
    const slideimg = tabProtect.data.slider_images[i];
    slideimg.slider_img_url = slideimg.slider_img_url.replace("public://", "");
  }
  // Show loading state
  if (loading && loading1 ) {
    return <Load />;
  }
  
  // if (error1 ) return <div>Error: {error1}</div>;
  // if (error) {
  //   return (
  //     <div className="error-container">
  //       <h2>Something went wrong</h2>
  //       <p>{error}</p>
  //     </div>
  //   );
  // }

  if (!data) {
    return <div>No data available</div>;
  }


  return (
    <>
     
     { /*<SolutionDebug data={data} loading={loading} error={error} /> */ }
      <main className="main">
        {/* Hero Section - Load immediately */}
        {data.hero && (
          <SolutionHero 
            data={data.hero.data}
            image={data.hero.image}
            mobimage={data.hero.mobimage}
          />
        )}

        {/* About Section - Load when available */}
        {data.about && (
          <SolutionAbout 
            data={data.about.data}
            image={data.about.image}
          />
        )}

        {/* Benefits Section - Lazy load */}
        {data.benefits && (
          <LazySection>
            <BenefitsSection 
              data={data.benefits.data}
              items={data.benefits.items}
            />
          </LazySection>
        )}

        {/* Tabs Section - Lazy load */}
        {/* {data.tabs && data.tabs.data && (
          <LazySection>
            <SolutionTabs 
              tabData={data.tabs.data}
              groone={data.tabs.groone}
               grocredit={data.tabs.grocredit}
            />
          </LazySection>
        )} */}
     
        <section id="tababoutgrocreditnOne" className="section d-block">
          <ul className="nav justify-content-center slide-nav">
            {solTab?.data?.slider_images?.map((slide:any, index:number) => (
              <li key={slide.entity_id || index} className="nav-item">
                <button 
                  type="button" 
                  data-bs-toggle="tab" 
                  data-bs-target={`#tab-gro${slide.entity_id || index}`} 
                  className={`nav-link ${index === 0 ? 'active' : ''}`}
                  aria-current={index === 0 ? 'page' : undefined}
                  aria-label={`Slide ${index + 1}`}  style={{ border: "1px solid #003cff" }}
                >
                  {slide.button_title || `Tab ${index + 1}`}
                </button>
              </li>
            ))}
          </ul>

          <div className="tab-content">
            {solTab?.data?.slider_images?.map((slide:any, index:number) => (
              <div 
                key={slide.entity_id || index}
                className={`tab-pane fade ${index === 0 ? 'active show' : ''}`} 
                id={`tab-gro${slide.entity_id || index}`} 
                role="tabpanel"
              >
                <section id="aboutgroCredit" className="about section mt-0 bg-grey-gradient">
                  <div className="container">
                    <div className="row gx-2 align-items-xl-start gy-5 flex-lg-row-reverse">
                      {/* Content */}
                      <div className="col-xl-6 col-sm-12 content mt-4 pe-5 aos-init aos-animate" 
                        data-aos="fade-up" data-aos-delay="100">
                        <label className="label-title" dangerouslySetInnerHTML={{ __html: slide.slider_title || 'Default Title' }} />
                        <p className="py-3" dangerouslySetInnerHTML={{ __html: slide.slider_desc || 'Default Description' }} />
                      </div>

                      {/* Image */}
                      <div className="col-xl-5 col-sm-12 d-flex align-items-center aos-init aos-animate" 
                        data-aos="zoom-out" data-aos-delay="100">
                        <div className="row gy-4">
                          <div className="col-sm-12 text-center">
                            {slide.slider_img_url && (
                              // <OptimizedImage
                              //   src={`${imagePath}${slide.slider_img_url}`}
                              //   className="img-fluid px-lg-5 mb-5"
                              //   alt={slide.button_title || 'Tab Image'}
                              //   loading="lazy"
                              // />
                                <img src={`${imagePath}${slide.slider_img_url}`} className="img-fluid px-lg-5 mb-5" />
                            )}
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Digital Features */}
                       <div className="row gx-2 text-center">
                    
                      <div className="col-sm-12 text-center" data-aos="fade-in">
                          { slide.button_title === tabone?.data?.slidername &&  <h4>{tabone?.data?.description ? tabone?.data?.description.replace(/<\/?p>/g, '') : ''} </h4> } 
                          { slide.button_title === tabcredit?.data?.slidername &&  <h4>{tabcredit?.data?.description ? tabcredit?.data?.description.replace(/<\/?p>/g, '') : ''} </h4> }
                           { slide.button_title === tabProtect?.data?.slidername &&  <h4>{tabProtect?.data?.description ? tabProtect?.data?.description.replace(/<\/?p>/g, '') : ''} </h4> }  

                      </div>
                      {slide.button_title === tabone?.data?.slidername ? (
                        tabone?.data?.slider_images?.map((slide:any, index:number)  => (
                        <div key={index} className="col-lg-3 col-sm-6">
                          <div className="abtcard">
                            <div className="img-holder" data-aos="zoom-out" data-aos-delay="100">
                              {slide.slider_img_url && (
                                <img src={`${imagePath}${slide.slider_img_url}`} className="img-fluid " />
                              )}
                            </div>
                           {/* <h3 className='soltabtitle'> {slide.slider_title ? slide.slider_title.replace(/<\/?p>/g, '') : ''} </h3>
                            <p className="soltabpara" > {slide.slider_desc ? slide.slider_desc.replace(/<\/?p>/g, '') : ''} </p> */}
                        <h3 className='soltabtitle'> {slide.slider_title ? slide.slider_title.replace(/<\/?p>/g, '') : ''} </h3>
                            <p className="soltabpara" > {slide.slider_desc ? slide.slider_desc.replace(/<\/?p>/g, '') : ''} </p>
                          </div>
                        </div>
                      ))) : ( <p className="mb-0"></p> )}

                      {slide.button_title === tabcredit?.data?.slidername ? (
                        tabcredit?.data?.slider_images?.map((slide:any, index:number)  => (
                        <div key={index} className="col-lg-3 col-sm-6">
                          <div className="abtcard">
                            <div className="img-holder" data-aos="zoom-out" data-aos-delay="100">
                              {slide.slider_img_url && (
                                <img src={`${imagePath}${slide.slider_img_url}`} className="img-fluid " />
                              )}
                            </div>
                          <h3 className='soltabtitle'> {slide.slider_title ? slide.slider_title.replace(/<\/?p>/g, '') : ''} </h3>
                            <p className="soltabpara" > {slide.slider_desc ? slide.slider_desc.replace(/<\/?p>/g, '') : ''} </p>
                          </div>
                        </div>
                      ))) : ( <p className="mb-0"></p>)}
                      
                      {slide.button_title === tabProtect?.data?.slidername ? (
                        tabProtect?.data?.slider_images?.map((slide:any, index:number)  => (
                        <div key={index} className="col-lg-3 col-sm-6">
                          <div className="abtcard">
                            <div className="img-holder" data-aos="zoom-out" data-aos-delay="100">
                              {slide.slider_img_url && (
                                <img src={`${imagePath}${slide.slider_img_url}`} className="img-fluid " />
                              )}
                            </div>
                            
                             <h3 className='soltabtitle'> {slide.slider_title ? slide.slider_title.replace(/<\/?p>/g, '') : ''} </h3>
                            <p className="soltabpara" > {slide.slider_desc ? slide.slider_desc.replace(/<\/?p>/g, '') : ''} </p>
                          </div>
                        </div>
                      ))) : ( <p className="mb-0"></p>)}
                    </div>
                 
                  </div>
                </section>
              </div>
            ))}
          </div>
        </section>

        {/* Testimonials */}
        {/* <TestimonalSliderClient /> */}
      </main>
    </>
  );
};

export default Solution;